<mat-toolbar *ngIf="hasSubmission">
  <span>{{ hostDice.user }}'s Submission: {{ hostDice.count }} - {{ hostDice.die }}'s</span>
</mat-toolbar>

<div class="page-container"
  [class.has-footer]="canChallenge || showReady || submitMode"
  [class.has-footer-2]="canChallenge"
  [class.has-footer-3]="canChallenge && canChallengeExact"
>
  <div *ngIf="showReady || showWaiting" class="avatar-container">
    <img class="avatar" src="{{ user.avatar }}" />
    <p>{{ user.name }}</p>
  </div>

  <div class="ready-waiting-message-container" *ngIf="showReady || showWaiting">
    <p *ngIf="showReady">Wait until all users are logged in and then click Ready!</p>
    <p *ngIf="showWaiting">Sit tight and relax...</p>
  </div>

  <div *ngIf="!showWaiting && !showReady">
    <div class="dice-container">
      <h1>Your Dice:</h1>
      <span *ngFor="let die of dice" class="dice dice-{{ die }}"></span>
    </div>

    <div class="inprogress-wait" *ngIf="!submitMode">
      <img class="avatar" src="{{ user.avatar }}" />
      <p><strong>{{ user.name }}</strong></p>

      <p *ngIf="!canChallenge">
        Hang tight while <strong>{{ turnUserName }}</strong> submits their dice.
      </p>

      <div *ngIf="canChallenge">
        <p>
          Hang tight while <strong>{{ turnUserName }}</strong> submits their dice.
        </p>
        <p>
          If you think that <strong>{{ hostDice.user }}'s</strong> submission is a lie, challege them!
        </p>
        <p>Remember! 1's are wild, and count towards {{ hostDice.user }}'s dice count</p>
      </div>
    </div>

    <div *ngIf="submitMode" class="current-submit-container">
      <label>Choose Amount of Dice:</label>
      <input class="form-control" [(ngModel)]="diceGuess.count" min="1" type="number" />

      <label>Choose a Die:</label>
      <div class="dice-selection-container">
        <button *ngFor="let d of defaultDice" [class.selected]="diceGuess.die === d" (click)="selectDie(d)">
          <span class="dice dice-{{ d }}"></span>
        </button>
      </div>

      <div class="current-guess-container">
        <h2>Your Submission:</h2>
        <h1>{{ diceGuess.count }} - {{ diceGuess.die }}'s</h1>
      </div>
    </div>
  </div>
</div>

<div class="footer-bar-container" *ngIf="canChallenge || showReady || submitMode">
  <div class="footer-bar-content">
    <button *ngIf="submitMode" mat-raised-button color="primary" class="full-width" (click)="sendGuess()" [disabled]="!submitMode">Submit</button>
    <button *ngIf="canChallenge" mat-raised-button color="accent" class="full-width" (click)="sendChallenge()" [disabled]="!canChallenge">Challenge!</button>
    <button *ngIf="canChallenge && canChallengeExact" mat-raised-button color="accent" class="full-width" (click)="sendChallenge(true)" [disabled]="!canChallenge">Exacto!</button>
    <button *ngIf="showReady" mat-raised-button color="primary" class="ready-button full-width" (click)="onReadyHandler()">Ready!</button>
  </div>
</div>
